module.exports = __webpack_public_path__ + "img/KEC-inside-blued.3c114d1e.jpg";